import { AJOUTE_CLIENT, SUPRIMER_CLIENT } from '../types/typeClient';
const client = [];
const ClientReducer = (state = client, action) => {
    if (localStorage.getItem('client')) {
        state = JSON.parse(localStorage.getItem('client'));
    }
    switch (action.type) {
        case AJOUTE_CLIENT:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_CLIENT:
            return state = [];
        default:
            return state;

    }
}

export default ClientReducer;